import { render, staticRenderFns } from "./UpsellVueComponent.vue?vue&type=template&id=072b71ea&"
import script from "./UpsellVueComponent.vue?vue&type=script&lang=ts&"
export * from "./UpsellVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./UpsellVueComponent.vue?vue&type=style&index=0&id=072b71ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports